<template>
    <div class="div-custom">
        <div class="f-btn" style="width: 200px;" @click="add('store')">
            <i class="el-icon-circle-plus-outline"></i>添加小组
        </div>
        <div class="team">
            <el-tree :data="treeData" node-key="index" :expand-on-click-node="false" custom-class="team_tree"
                     @node-collapse="nodeCollapse" @node-expand="nodeExpand" :default-expanded-keys="defaultExpandKeys">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span style="font-size:16px;" class="tree_compony">
                            {{ node.label }}
                            <span v-if="data.bool_leader === 1" class="group_logo"></span>
                        </span>
                        <span class="tree_btn" :class="'tree_btn'+node.level">
                            <template>
                                <span @click="()=>add('update',data)" v-show="node.level === 1 " class="tree_span">
                                    <i class="iconfont iconbianjix"></i>
                                    <em>编辑</em>
                                </span>
                            </template>
                            <template>
                                <span @click="()=>remove(node, data)" v-show="node.level === 1 " class="tree_span">
                                    <i class="iconfont iconshanchu1"></i>
                                    <em>删除</em>
                                </span>
                            </template>
                        </span>
                    </span>
            </el-tree>
        </div>
        <el-dialog :title="title" :visible.sync="addDialog" custom-class="tree_dialog">
            <!-- 添加/编辑 -->
            <el-form :model="form" ref="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="小组名称" prop="name">
                            <el-input v-model="form.name" placeholder="请输入小组名称"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer" style="text-align: center">
                      <button-submit ref="buttonSubmit" button-txt="确定" style="width: 100px"
                                     @click.native.prevent="doStore"/>
                    <el-button type="cancel" @click="addDialog = false" style="width: 100px">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {tree, store, del} from '@/api/organization'

    export default {
        name: 'organization',
        data() {
            return {
                addDialog: false,
                type: 'store',
                title: '添加',
                treeData: [],
                form: {
                    name: ''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入小组名称', trigger: 'blur'},
                    ],
                },
                defaultExpandKeys: ['headOffice', 'company_1']
            }
        },
        created() {
            this.getData()
        },
        methods: {
            nodeCollapse(node) {
                this.defaultExpandKeys = this.defaultExpandKeys.filter(el => {
                    return el != node.index
                });
            },
            nodeExpand(node) {
                this.defaultExpandKeys.push(node.index);
            },
            getData() {
                tree().then((res) => {
                    if (res.model.length > 0) {
                        this.treeData = res.model;
                        this.treeData.forEach(els => {
                            els.label = els.name
                            els.children = els.users
                            els.children.forEach(e => {
                                e.label = e.name;
                            })
                        });
                    }
                })
            },
            //编辑
            add(val, data) {
                this.form.name = '';
                this.type = val
                this.addDialog = true
                if (val === 'store') {
                    this.form.id = '';
                    this.title = '添加小组'
                } else {
                    this.form.id = data.id;
                    this.form.name = data.name;
                    this.title = '编辑小组'
                }
            },
            // 删除
            remove(node, data) {
                let that = this
                that.showModal({
                    h: that,
                    text: '此操作将永久删除该小组, 是否继续?',
                    confirm: function () {
                        del({id: data.id}).then(res => {
                            that.$message.success(res.message);
                            that.getData()
                        })
                    },
                    cancel: function () {
                        that.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    }
                })
            },
            doStore() {
                let that = this
                that.$refs.form.validate((valid) => {
                    if (valid) {
                        let data = that.form;
                        store(data).then((res) => {
                            if (res.success) {
                                this.$message.success(res.message);
                                this.addDialog = false;
                                this.getData();
                                return false
                            }
                            this.$message.error(res.message)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .f-btn {
        margin: 30px;
        /*width: 100px;*/
        padding: 3px 8px;
        color: rgb(254, 45, 84);
        font-size: 14px;
        border: 1px solid rgb(254, 45, 84);
        border-radius: 2px;
        cursor: pointer;
    }
</style>
<style>
    .team .custom-tree-node {
        line-height: 36px;
        width: 100%;
        font-size: 14px;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
    }

    .team .custom-tree-node .tree_compony {
        margin-right: 50px;
    }

    .team .custom-tree-node .tree_btn {
        min-width: 317px;
        text-align: left;
    }

    .team .custom-tree-node .tree_btn .tree_span {
        margin-right: 15px;
    }

    .team .custom-tree-node .tree_btn .tree_span:hover {
        color: #0099FF;
    }

    .team .custom-tree-node .tree_btn.tree_btn3 {
        right: 531px;
    }

    .team .custom-tree-node .tree_btn span .iconfont {
        margin-right: 12px;
    }

    .team .custom-tree-node .tree_btn span .iconfont.iconbianjix {
        font-size: 82%
    }

    .team .custom-tree-node .tree_btn span .iconfont.iconshanchu1 {
        font-size: 90%
    }

    .team .custom-tree-node .tree_btn span {
        font-size: 20px;
        color: #666;
    }

    .team .custom-tree-node .tree_btn span i {
        vertical-align: top;
    }

    .team .custom-tree-node .tree_btn span em {
        font-size: 12px;
        display: inline-block;
        vertical-align: top;
        font-style: inherit;
    }

    .team .custom-tree-node .group_logo {
        width: 44px;
        height: 19px;
        background: url('../../assets/images/group.png') no-repeat center;
        display: inline-block;
        vertical-align: middle;
    }

    .team .el-tree-node__content {
        height: 40px !important;
    }

    .team {
        padding-left: 36px;
        margin-top: 32px;
    }

    .div-custom {
        background: #fff;
        padding: 20px;
        box-sizing: border-box;
        min-height: 820px;
    }
</style>
